export const LABEL_KH = {

}
